var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar__day",class:_vm.classList,on:{"click":function($event){return _vm.dayClick()}}},[_c('span',[_vm._v(_vm._s(_vm.day.dayNumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }